















































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class extends Vue {
  @Getter("auth/isAuthorized")
  public isAuthorized!: boolean;

  @Getter("isLoading")
  public isLoading!: boolean;

  public drawer = false;
  public menu = {
    regist: false,
    search: false
  };
  public items = [
    { title: "Click Me" },
    { title: "Click Me" },
    { title: "Click Me" },
    { title: "Click Me 2" }
  ];

  private goToBack() {
    this.$router.go(-1);
  }
}
